import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDemandbase = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	"data-name": "Layer 1",
	width: 46,
	height: 40,
	viewBox: "-28 0 179 204.66",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#4ca3ff",
		fillRule: "evenodd",
		d: "M0 0h75.52C132.59 0 179 36.25 179 102.33S132.59 204.66 75.52 204.66H0V99.81c0-23.57 18.84-42.68 42.08-42.68v109.8h31.7c32.29 0 61.4-21.05 61.4-64.6s-29.11-64.6-61.4-64.6H37.17C16.65 37.72 0 20.84 0 0Z"
	})
});
export default SvgDemandbase;
